import { FC } from 'react'
import { useTranslation } from "react-i18next"
import { RotationRightButton } from '../../../../components/buttons/iconButtons/action/RotationCollection'
import { HighLightButton } from '../../../../components/buttons/iconButtons/editor/ActionCollection'
import BaseCommandsPanel from '../../../../components/commandsPanels/BaseCommandsPanel'
import Tooltip from '../../../../components/tooltips/Tooltip'
import GridWrapper from '../../../../components/controls/GridWrapper'
import { checkActiveCommands } from '../../../CommonHelperFunctions'
import { useUserContext } from '../../../../system/providers/userContextProvider'
import { FilePlusButton } from '../../../../components/buttons/iconButtons/other/FileAndFolderCollection'

interface IPanelEvent {
    disabled?: boolean
    onClick: () => any
    onSubItemClick?: () => any,
    value?: any
}

interface ILoyaltyProgramPanelProps {
    add?: IPanelEvent
    edit?: IPanelEvent
    refresh?: IPanelEvent
    test?: IPanelEvent
    permission?: IPermission
}

export const LoyaltyProgramPanel: FC<ILoyaltyProgramPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value)
    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);

    return (
        <>
            <GridWrapper cols={5}>
                <BaseCommandsPanel groups={[
                    [
                        {
                            iconButton: <Tooltip title={baseT('addNote')}>
                                <FilePlusButton sizeVariant="mini" {...{ ...props.add, disabled: props.add?.disabled || !activeCommands.add }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('editNote')}>
                                <HighLightButton sizeVariant="mini" {...{ ...props.edit, disabled: props.edit?.disabled || !activeCommands.edit }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('refresh')}>
                                <RotationRightButton sizeVariant="mini" {...{ ...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh }} />
                            </Tooltip>
                        }
                    ],
                ]}
                />
            </GridWrapper>
        </>
    )
}
